import { render, staticRenderFns } from "./Rol.vue?vue&type=template&id=6a23ed5e"
import script from "./Rol.vue?vue&type=script&lang=js"
export * from "./Rol.vue?vue&type=script&lang=js"
import style0 from "./Rol.vue?vue&type=style&index=0&id=6a23ed5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports